import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/autoplay";
import { css } from "@emotion/react";
import { Heading } from "@/components/Typography";
import { mq } from "@/constants/breakpoints";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import TestimonialHero from "@/components/Homepage/TestimonialHero";

interface ShortTestimonialsSliderProps {
  testimonials: any[];
  heading?: string;
}

const ShortTestimonialsSlider = ({
  testimonials,
  heading = "Award-Winning Support",
}: ShortTestimonialsSliderProps) => (
  <div
    css={css`
      width: 100%;
      border-radius: 24px;
      margin: 0 auto;
    `}
  >
    <Heading
      level={2}
      css={css`
        margin-bottom: 24px;
        ${mq["lg"]} {
          margin-bottom: 60px;
        }
        font-size: 2.5rem;
        font-weight: 700;
        color: #243b4a;
      `}
    >
      {heading}
    </Heading>
    <Swiper
      modules={[FreeMode, Autoplay]}
      spaceBetween={24}
      freeMode={{ enabled: true, sticky: true }}
      autoplay={{
        delay: 3500,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
        stopOnLastSlide: false,
      }}
      loop
      breakpoints={{
        320: { slidesPerView: 1 },
        640: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
        1280: { slidesPerView: 4 },
      }}
      css={css`
        position: relative;
        .swiper-slide {
          display: flex;
          justify-content: center;
        }
        mask-image: linear-gradient(to right, black 80%, transparent 100%);
        -webkit-mask-image: linear-gradient(
          to right,
          black 80%,
          transparent 100%
        );
      `}
    >
      {testimonials.map((testimonial, idx) => (
        <SwiperSlide key={idx}>
          <TestimonialHero
            testimonial={testimonial}
            backgroundColor="#F5FBFF"
          />
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
);

export default ShortTestimonialsSlider;
